import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const StyledA = styled.a`
	font-weight: 600;
	color: ${tokens.color_primary};
	cursor: 'pointer';

	:visited {
		color: ${tokens.color_primary};
	}
`;
